export function preview(s, h) {
  const ta = `text-align:${s.align || "center"};`;
  const p = s.pad === "sm" ? "1rem 2rem" : s.pad === "lg" ? "3.5rem 2rem" : "2rem 2rem";
  const sty = s.style || "pill";
  const sz = s.size === "sm" ? ".5rem 1.4rem" : s.size === "lg" ? ".9rem 2.8rem" : ".7rem 2rem";
  const target = s.new_tab !== "no" ? 'target="_blank" rel="noopener"' : "";
  let bc;
  if (sty === "solid") bc = `background:${h.accent};color:${h.bg};border:none;`;
  else if (sty === "ghost")
    bc = `background:transparent;border:1px solid ${h.rgb(h.text, 0.25)};color:${h.text};`;
  else if (sty === "underline")
    bc = `background:none;border:none;border-bottom:1px solid ${h.rgb(h.accent, 0.5)};color:${h.accent};padding-bottom:.2rem;border-radius:0;`;
  else if (sty === "badge")
    bc = `background:${h.rgb(h.accent, 0.12)};border:1px solid ${h.rgb(h.accent, 0.25)};color:${h.accent};`;
  else
    bc = `background:none;border:1px solid ${h.rgb(h.accent, 0.3)};color:${h.accent};border-radius:40px;`;
  return `<div style="${h.ff}${h.fc}${ta}padding:${p};"><a href="${h.A(s.url || "#")}" ${target} style="${bc}display:inline-block;font-weight:300;font-size:.78rem;letter-spacing:.2em;text-transform:uppercase;padding:${sz};text-decoration:none;">${h.E(s.label || "Visit →")}</a></div>`;
}
export function render(s, h) {
  const ta = `text-align:${s.align || "center"};`;
  const p = s.pad === "sm" ? "1rem 2rem" : s.pad === "lg" ? "3.5rem 2rem" : "2rem 2rem";
  const sty = s.style || "pill";
  const sz = s.size === "sm" ? ".5rem 1.4rem" : s.size === "lg" ? ".9rem 2.8rem" : ".7rem 2rem";
  const target = s.new_tab !== "no" ? 'target="_blank" rel="noopener"' : "";
  let bc;
  if (sty === "solid") bc = `background:${h.accent};color:${h.bg};border:none;`;
  else if (sty === "ghost")
    bc = `background:transparent;border:1px solid ${h.rgb(h.text, 0.25)};color:${h.text};`;
  else if (sty === "underline")
    bc = `background:none;border:none;border-bottom:1px solid ${h.rgb(h.accent, 0.5)};color:${h.accent};padding-bottom:.2rem;border-radius:0;`;
  else if (sty === "badge")
    bc = `background:${h.rgb(h.accent, 0.12)};border:1px solid ${h.rgb(h.accent, 0.25)};color:${h.accent};`;
  else
    bc = `background:none;border:1px solid ${h.rgb(h.accent, 0.3)};color:${h.accent};border-radius:40px;`;
  return `<div style="${h.ff}${h.fc}${ta}padding:${p};"><a href="${h.A(s.url || "#")}" ${target} style="${bc}display:inline-block;font-weight:300;font-size:.78rem;letter-spacing:.2em;text-transform:uppercase;padding:${sz};text-decoration:none;">${h.E(s.label || "Visit →")}</a></div>`;
}
